export default {
  years: 'سنة | سنوات',
  months: 'شهر | أشهر',
  days: 'يوم | أيام',
  hours: 'ساعة | ساعات',
  minutes: 'دقيقة | دقائق',
  seconds: 'ثانية | تواني'
}
